import "./Page.styl";

import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { fields } from "../../common/lib/redux-fields";
import { ValidationError } from "../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";
import ButtonWithLoader from "../components/Form/ButtonWithLoader";
import Input from "../components/Form/Input";

import { create } from "../../common/mails/actions";
import { clearError, clearForm } from "../../common/mails/actions";

const formFields = ["name", "email", "message", "policy"];

class Form extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.clearError = this.clearError.bind(this);
  }

  componentDidMount() {
    const { fields, clearForm } = this.props;

    fields.$reset();
    clearForm();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields } = this.props;
    const { create, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$values();

    const rs = await create(values);

    if (rs && rs.status >= 200 && rs.status <= 299) {
      fields.$reset();
      clearForm(true);

      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "success",
          eventLabel: "contact"
        });
      }
    } else {
      if (typeof ga !== typeof undefined) {
        window.ga("send", "event", {
          eventCategory: "email",
          eventAction: "error",
          eventLabel: "contact"
        });
      }
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { fields, form, isSent } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;

    return (
      <div className="form-section">
        <div className="width-wrapper wrapper-padding">
          <Row className="flex-items-xs-center">
            <Col className="text-xs-center" xs="12" sm="10">
              <div className="title">
                Formularz kontaktowy
              </div>
            </Col>
          </Row>
          <Row className="flex-items-xs-center">
            <Col xs="12" sm="8">
              <BootstrapForm
                className="contact-form row"
                onSubmit={this.create}
                noValidate
              >
                <Col xs="12" sm="6">
                  <Input
                    field="name"
                    title="Imię i nazwisko"
                    type="text"
                    loading={form.get("loading")}
                    error={form.get("error")}
                    clearError={this.clearError.bind(this, "name")}
                    {...fields.name}
                  />
                </Col>
                <Col xs="12" sm="6">
                  <Input
                    field="email"
                    title="Email"
                    type="email"
                    loading={form.get("loading")}
                    error={form.get("error")}
                    clearError={this.clearError.bind(this, "email")}
                    {...fields.email}
                  />
                </Col>
                <Col xs="12">
                  <Input
                    field="message"
                    title="Wiadomość"
                    type="textarea"
                    loading={form.get("loading")}
                    error={form.get("error")}
                    clearError={this.clearError.bind(this, "message")}
                    {...fields.message}
                  />
                  <Input
                    field="policy"
                    title="Akceptuję politykę prywatności"
                    type="checkbox"
                    loading={form.get("loading")}
                    error={form.get("error")}
                    clearError={this.clearError.bind(this, "policy")}
                    {...fields.policy}
                  />
                  {ValidationError.isInvalid(form.get("error"), "all") &&
                    <FormFeedback className="form-error">
                      Błąd wysyłania formularza - spróbuj ponownie później lub napisz na adres powyżej.
                    </FormFeedback>}
                  {isSent &&
                    <FormFeedback className="form-success">
                      Formularz został wysłany pomyślnie!
                    </FormFeedback>}
                </Col>
                <Col xs="12">
                  <ButtonWithLoader
                    className="button-loader"
                    size="lg"
                    color={"secondary"}
                    text={"Wprowadź dane"}
                    isLoading={form.get("loading")}
                    loadingText={"Wysyłam formularz..."}
                    isDirty={dirty}
                    dirtyText={"Wyślij"}
                  />
                </Col>
              </BootstrapForm>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: "mailForm",
  fields: formFields,
  getInitialState: () => {
    return {
      name: "",
      email: "",
      message: "",
      policy: false
    };
  }
});

Form = connect(
  state => ({
    form: state.mails.form,
    isSent: state.mails.isSent
  }),
  { create, clearError, clearForm }
)(Form);

export { Form, formFields };



/** WEBPACK FOOTER **
 ** ./src/browser/contact/Form.js
 **/